import { useMemo } from "react";
import { useLanguage } from "../context/LanguageContext";
import { buildWhatsAppUrl, buildTelegramUrl } from "../config/contactLinks";

/**
 * Готовые ссылки WhatsApp / Telegram с текстом-шаблоном на текущем языке.
 */
export function useMessengerLinks() {
  const { t } = useLanguage();

  return useMemo(
    () => ({
      waReview: buildWhatsAppUrl(t("contact.waPrefillReview")),
      waConsult: buildWhatsAppUrl(t("contact.waPrefillConsult")),
      waDemo: buildWhatsAppUrl(t("contact.waPrefillDemo")),
      waNav: buildWhatsAppUrl(t("contact.waPrefillNav")),
      tgContact: buildTelegramUrl(t("contact.tgPrefillContact")),
      tgDemo: buildTelegramUrl(t("contact.tgPrefillDemo")),
    }),
    [t]
  );
}
